import { createFeatureSelector, createSelector } from "@ngrx/store";
import { AUTH_FEATURE_NAME, AuthState } from "./auth.reducer";

export const selectAuthState = createFeatureSelector<AuthState>(AUTH_FEATURE_NAME);
export const selectorCurrentUser = createSelector(selectAuthState, ({ user }: AuthState) => user?.data);
export const selectorCurrentUserStatus = createSelector(selectAuthState, ({ user }: AuthState) => user?.status);
export const selectorBusinessId = createSelector(selectAuthState, ({ businessId }: AuthState) => businessId);
